var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sdv-chart"},[_c('div',{ref:"el",staticClass:"el"}),(_vm.badData)?_c('div',{staticClass:"overlay"},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t('no_data_for_these_filters')))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }